import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { Toast } from '@app/design-system/toast/toast';
import { ToastPayload } from '../toast-payload';

@Component({
    selector: 'app-toast-container',
    templateUrl: './toast-container.html',
    styleUrl: './toast-container.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'app-toast-container',
    },
    imports: [
        Toast,
    ],
})
export class ToastContainer {
    /**
     * The list of toasts to be displayed. Defaults to an empty array.
     */
    public readonly toasts: InputSignal<readonly ToastPayload[]> = input<readonly ToastPayload[]>([]);

    /**
     * Emits the ID of a toast that should be closed.
     */
    public readonly closeToast: OutputEmitterRef<string> = output<string>();
}